export var Action;
(function (Action) {
    Action["MANAGE"] = "manage";
    Action["CREATE"] = "create";
    Action["READ_ALL"] = "read_all";
    Action["READ_ONE"] = "read_one";
    Action["UPDATE"] = "update";
    Action["DELETE"] = "delete";
    Action["ASSIGN"] = "assign";
})(Action || (Action = {}));
//# sourceMappingURL=action.enum.js.map